<ng-container *ngIf="svgIcon">
    <span 
    [innerHTML]="svgIcon" 
    class="d-flex align-items-center justify-content-center"
    (mouseenter)="onMouseEnter()" 
    (mouseleave)="onMouseLeave()"
    ></span>
  </ng-container>